import { formatPatientName } from "./controleFormat";

export const PATIENT_VALIDATION_KEY = "_patientValidated";

export const PATIENT_SHARED_COMMENT_KEY = "_points234Comment";

export const PATIENT_CONTROL_POINT_KEYS = ["tracageLogiciels", "datesProduction", "posologies"];

export function normalizePatientPointState(value) {
    if (typeof value === "boolean") return { validated: value, comment: "", launchStatus: "", launchStatusAt: "", launchStatusBy: "" };
    return {
        validated: Boolean(value?.validated),
        comment: value?.comment || "",
        launchStatus: value?.launchStatus || "",
        launchStatusAt: value?.launchStatusAt || "",
        launchStatusBy: value?.launchStatusBy || "",
    };
}

export function isPatientPointTouched(point) {
    return point.validated || Boolean(point.comment?.trim()) || Boolean(point.launchStatus);
}

export function isPatientControlValidated(value) {
    return Boolean(value?.[PATIENT_VALIDATION_KEY]);
}

export function isControlePatientActive(patient) {
    return !patient?.inactive;
}

export function patientControlSortRank(patient, value) {
    if (!isControlePatientActive(patient)) return 2;
    return isPatientControlValidated(value) ? 1 : 0;
}

export function firstControlePatientId(rows) {
    const firstPatient = [...(rows || [])]
        .sort((a, b) => patientControlSortRank(a, {}) - patientControlSortRank(b, {})
            || formatPatientName(a).localeCompare(formatPatientName(b), "fr", { sensitivity: "base" }))[0];
    return firstPatient?.patientId ? String(firstPatient.patientId) : "";
}

export function patientControlsForDossier(dossier, patientId) {
    const controls = dossier?.donnees?.controlePatients || {};
    return controls[patientId] || controls[String(patientId)] || null;
}

export function isPatientControlFullyValidated(value) {
    return isPatientControlValidated(value)
        && PATIENT_CONTROL_POINT_KEYS.every(pointKey => normalizePatientPointState(value?.[pointKey]).validated);
}

export function sameProductionSubcategory(patient, subcategory) {
    if (!subcategory) return true;
    return String(patient?.productionSubcategory || "").trim() === String(subcategory).trim();
}

export function sharedPatientControlComment(value) {
    const sharedComment = value?.[PATIENT_SHARED_COMMENT_KEY];
    if (typeof sharedComment === "string") return sharedComment;
    return PATIENT_CONTROL_POINT_KEYS
        .map(pointKey => normalizePatientPointState(value?.[pointKey]).comment)
        .find(comment => comment?.trim()) || "";
}
